module.exports = __webpack_public_path__ + "img/LineCircleIcon.5bf3d86c.svg";